import { Space } from 'antd';
import TimeframeFilter from 'components/molecules/oneplaform/timeframe-filter';
import styles from 'pages/homeDashboard/styles.module.scss';
import { type FC, type ReactNode } from 'react';

import type { ITimeframeFilterProps } from 'components/molecules/oneplaform/timeframe-filter/types';

type DashboardSidebarProps = {
  timeframeFilterProps: ITimeframeFilterProps;
  children?: ReactNode;
};

const DashboardSidebar: FC<DashboardSidebarProps> = ({
  timeframeFilterProps,
  children,
}) => (
  <div
    className={styles.sidebar}
    role="complementary"
    aria-label="Pinned left column"
  >
    <div className={styles['sidebar-filter']}>
      <TimeframeFilter {...timeframeFilterProps} />
    </div>
    <Space direction="vertical" size={16} className={styles['sidebar-stack']}>
      {children}
    </Space>
  </div>
);

export default DashboardSidebar;
